import React from 'react'

interface DocNotesProps {
  notes?: string | string[]
}

import { useFeatureFlag } from '../hooks/useFeatureFlag'

import DocNotesV2 from './DocNotesV2'

const DocNotes: React.FC<DocNotesProps> = ({ notes }) => {
  const { useNewDocumentUI } = useFeatureFlag()

  if (useNewDocumentUI) return <DocNotesV2 notes={notes as string} />

  const notesStr = Array.isArray(notes) ? notes.join('\n') : (notes ?? '')
  const noteLines = notesStr.split('\n').filter((line) => line.trim() !== '') // Remove any empty lines

  return (
    <div className="mb-2">
      <span className="font-bold">Observaciones</span>
      {noteLines.length > 0 ? (
        noteLines.map((line, index) => (
          <div key={line + '-' + index} className="mb-0">
            {line}
          </div>
        ))
      ) : (
        <div className="mb-0">No se registran observaciones.</div>
      )}
    </div>
  )
}

export default DocNotes
